import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "hrm_lang";

const readInitialLang = () => {
  if (typeof window === "undefined") return "en";
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "es") return stored;
  } catch (error) {
    console.warn("LanguageContext: localStorage read failed", error);
  }
  const browser = (typeof navigator !== "undefined" ? navigator.language : "en") || "en";
  return browser.toLowerCase().startsWith("es") ? "es" : "en";
};

const persistLang = (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch (error) {
    console.warn("LanguageContext: localStorage write failed", error);
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(readInitialLang);

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "en" ? "es" : "en";
      persistLang(next);
      return next;
    });
  }, []);

  const setLangPersist = useCallback((value) => {
    setLang(value);
    persistLang(value);
  }, []);

  const value = useMemo(
    () => ({ lang, setLang: setLangPersist, toggle, t: translations[lang] }),
    [lang, setLangPersist, toggle]
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
